import { useIntl } from 'gatsby-plugin-intl';
import React from 'react';
import { Helmet } from 'react-helmet';

import favicon from 'images/favicon.png';
import socialPreview from 'images/social-preview.png';

const SEO: React.FC = () => {
  const intl = useIntl();

  const description = intl.formatMessage({ id: 'meta.description' });
  const title = intl.formatMessage({ id: 'meta.title' });
  const author = intl.formatMessage({ id: 'meta.author' });

  return (
    <Helmet
      titleTemplate="%s | Albums"
    >
      <html lang={intl.locale} prefix="og: http://ogp.me/ns#" />
      <meta charSet="utf-8" />
      <title>{title}</title>

      <link rel="icon" type="image/png" href={favicon} />
      <link rel="shortcut icon" type="image/png" href={favicon} />

      <meta name="description" content={description} />
      <meta name="img" content={socialPreview} />

      {/* Facebook/Telegram (OpenGraph) */}

      <meta name="og:title" content={title} />
      <meta name="og:description" content={description} />
      <meta name="og:type" content="website" />
      <meta name="og:image" content={socialPreview} />

      {/* Twitter */}

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={socialPreview} />
      <meta name="twitter:creator" content={author} />
      <meta name="twitter:site" content={author} />
    </Helmet>
  );
};

export default SEO;
